import React from 'react'

function ProcurementView() {
    return (
        <div>ProcurementView</div>
    )
}

export default ProcurementView